<template>
    <div class="conveyorbelt-main">
        <Row :gutter="15">
            <Col span="8">
                <Card style="margin-bottom:15px;" :bordered="false">
                    <p slot="title">
                        <Icon type="md-apps"/>
                        &nbsp;{{$t('baseInfo')}}
                    </p>
                    <dl class="base-dl">
                        <dt>{{$t('deviceName')}}</dt>
                        <dd>{{device.name}}</dd>
                        <dt>{{$t('deviceModel')}}</dt>
                        <dd>{{device.model}}</dd>
                        <dt>{{$t('deviceSerial')}}</dt>
                        <dd>{{device.order_code}}</dd>
                        <dt>{{$t('deviceRegisteTime')}}</dt>
                        <dd>{{device.created | formatTime}}</dd>
                    </dl>
                </Card>
                <Card :bordered="false">
                    <p slot="title">
                        <Icon type="md-cloudy"/>
                        &nbsp;{{$t('realTimeData')}}
                    </p>
                    <a href="javascript:;" slot="extra">
                        <Icon type="md-settings" @click="showAttrsModal"/>
                    </a>
                    <dl class="dat-dl">
                        <template v-if="attrs.status">
                            <dt>{{$t('runStatus')}}</dt>
                            <dd>{{status[dat.status] ? status[dat.status] : '--'}}</dd>
                        </template>
                        <template v-if="attrs.err">
                            <dt>{{$t('runError')}}</dt>
                            <dd>{{error}}</dd>
                        </template>
                        <template v-if="attrs.time">
                            <dt>{{$t('updateTime')}}</dt>
                            <dd>{{dat.time ? dat.time : '--'}}</dd>
                        </template>
                    </dl>
                </Card>
            </Col>
            <Col span="16">
                <Row :gutter="15" style="margin-bottom:15px;">
                    <Col span="16">
                        <Card :bordered="false">
                            <p slot="title">
                                <Icon type="md-eye"/>
                                &nbsp;{{$t('watchData')}}
                            </p>
                            <div class="watch">
                                <div class="w-item">
                                    <p class="tx">{{$t('runStatus')}}</p>
                                    <p class="val">{{status[dat.status] ? status[dat.status] : '--'}}</p>
                                </div>
                                <div class="w-item">
                                    <p class="tx">{{$t('powerkwh')}}(kW·h)</p>
                                    <p class="val">{{dat.power|format(10, 1, '')}}</p>
                                </div>
                            </div>
                        </Card>
                    </Col>
                    <Col span="8">
                        <StatusChart :item="statusDat" :uuid="device.uuid"></StatusChart>
                    </Col>
                </Row>
                <Card :bordered="false">
                    <p slot="title">
                        <Icon type="md-stats"/>
                        &nbsp;{{$t('realTimeChart')}}
                    </p>
                    <div ref="echart" class="echart-line">
                        <p style="display:flex;height:100%;align-items:center;justify-content: center;font-size: 30px;">{{$t('noChart')}}</p>
                    </div>
                </Card>
            </Col>
        </Row>
        <!-- 设置显示的属性 -->
        <Modal v-model="attrsModal.show" @on-ok="doChangeAttrs" @on-cancel="attrsModal.show = false" width="600" :ok-text="$t('ok')" :cancel-text="$t('cancel')">
            <p slot="header">
                <Icon type="md-pricetag"/>
                <span>{{$t('b_setShowProperies')}}</span>
            </p>
            <div class="data-attrs clearfix">
                <Checkbox v-model="attrsModal.attrs.status">{{$t('runStatus')}}</Checkbox>
                <Checkbox v-model="attrsModal.attrs.err">{{$t('runError')}}</Checkbox>
                <Checkbox v-model="attrsModal.attrs.time">{{$t('updateTime')}}</Checkbox>
            </div>
        </Modal>
    </div>
</template>

<script>
import StatusChart from './statuschart.vue';
import Axios from 'axios';
import AxiosUrl from '@/axiosurl.js';
import Moment, { now } from 'moment';
// import echarts from 'echarts';

export default {
    props: {
        device: Object
    },
    components: {
        StatusChart
    },
    data() {
        return {
            dat: {}, // 实时数据
            statusDat: {
                run: 0,
                stby: 0,
                alarm: 0,
                off: 0,
                stop: 0,
                status: 0
            }, // 状态饼图
            // 属性显示控制
            attrs: sessionStorage.getItem('conveyorbelt_attrs')
                ? JSON.parse(sessionStorage.getItem('conveyorbelt_attrs'))
                : {
                      status: true, // 运行状态（0：停止，1：运行，2：待机，3：报警，4：离线）
                      err: true, // 故障
                      time: true // 更新时间
                  },
            attrsModal: {
                show: false,
                attrs: {}
            }, // 实时数据显示控制
            status: [this.$t('stop'), this.$t('run'), this.$t('stby'), this.$t('alarm'), this.$t('off')] // 运行状态
        };
    },
    computed: {
        error() {
            let err1 = ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''];
            // let err2 = ['进水水压低', '禁用', '增压泵过载', '首次温度过高', '首次温度过低', '系统压力高', '液温高', '', '', '', '', '', '', '', '', ''];
            let err = [].concat(
                err1.filter((item, index) => {
                    return ((this.dat.err1 >> index) & 1) == 1;
                })
            );
            if (err.length > 0) {
                return err.join(',');
            }
            return '--';
        }
    },
    mounted() {
        this.getRealTime();
        let datIntval = setInterval(() => {
            this.getRealTime();
        }, 3000);
        this.$once('hook:beforeDestroy', () => {
            clearInterval(datIntval);
        });
        // 图表初始化
        // let dom = this.$refs.echart;
        // this.myChart = echarts.init(dom);
        // 初始化原始数据
        // let now = Moment().unix();
        // for (let i = 60; i > 0; i--) {
        //     this.tempOption.series[0].data.push([(now - i) * 1000, '-']);
        //     this.tempOption.series[1].data.push([(now - i) * 1000, '-']);
        //     this.tempOption.series[2].data.push([(now - i) * 1000, '-']);
        //     this.tempOption.series[3].data.push([(now - i) * 1000, '-']);
        //     this.tempOption.series[4].data.push([(now - i) * 1000, '-']);
        //     this.pressOption.series[0].data.push([(now - i) * 1000, '-']);
        // }
        // this.myChart.setOption(this.tempOption);
    },
    methods: {
        // 获取实时数据
        getRealTime() {
            Axios.get(AxiosUrl.device.currentdata, {
                params: {
                    serial: this.device.uuid
                }
            })
                .then(res => {
                    let {
                        code,
                        data: { data: dat, time }
                    } = res.data;
                    if (code == 200) {
                        this.dat = JSON.parse(dat);
                        this.dat.time = time;
                        // 判断超时 15s
                        if (time == '' || Moment().unix() > Moment(time, 'YYYY-MM-DD HH:mm:ss').unix() + 300) {
                            this.dat.status = 4; // 离线
                            this.statusDat.status = 4; // 离线
                            this.dat.err1 = 0;
                            this.dat.power = '--';
                        }
                        // this.updateChart();
                    }
                })
                .catch(error => {});
        },
        // 显示修改属性对话框
        showAttrsModal() {
            this.attrsModal.attrs = Object.assign({}, this.attrs);
            this.attrsModal.show = true;
        },
        // 确认修改
        doChangeAttrs() {
            this.attrs = this.attrsModal.attrs;
            sessionStorage.setItem('conveyorbelt_attrs', JSON.stringify(this.attrs));
        }
        // 更新图表
        // updateChart() {
        //     let now = Moment().unix() * 1000;
        //     this.tempOption.series[0].data.shift();
        //     this.tempOption.series[0].data.push([now, this.dat.sv / 10]);
        //     this.tempOption.series[1].data.shift();
        //     this.tempOption.series[1].data.push([now, this.dat.pv / 10]);
        //     this.tempOption.series[2].data.shift();
        //     this.tempOption.series[2].data.push([now, this.dat.back / 10]);
        //     this.tempOption.series[3].data.shift();
        //     this.tempOption.series[3].data.push([now, this.dat.dp / 10]);
        //     this.tempOption.series[4].data.shift();
        //     this.tempOption.series[4].data.push([now, this.dat.cadp / 10]);
        //     this.pressOption.series[0].data.shift();
        //     this.pressOption.series[0].data.push([now, this.dat.cap / 10]);
        //     switch (this.chartType) {
        //         case 0:
        //             this.myChart.setOption(this.tempOption);
        //             break;
        //         case 1:
        //             this.myChart.setOption(this.pressOption);
        //             break;
        //     }
        // },
        // // 切换图表
        // changeEchartType(type) {
        //     switch (type) {
        //         case 0:
        //             this.myChart.setOption(this.tempOption, { notMerge: true });
        //             break;
        //         case 1:
        //             this.myChart.setOption(this.pressOption, { notMerge: true });
        //             break;
        //     }
        // }
    }
};
</script>
<style lang="less">
// .conveyorbelt-main {
//     margin-top: -35px;
// }
</style>



// WEBPACK FOOTER //
// src/views/group/components/conveyorbelt.vue